import {
  DeviceInterfaceType,
  instanceOfQaEquipmentCatalogDto,
  instanceOfQaEquipmentRtSystemDto,
  MedicalSystemCatalogDto,
  MedicalSystemRtSystemDto,
  QaEquipmentCatalogDto,
  QaEquipmentRtSystemDto,
  UnicheckDeviceDto,
  UnicheckSimulatorDto,
} from '@/api/generator';

// Typeguard needs to be adjusted as soon as other PTWDevices are there
export function isIOTDevice(
  rtSystem:
    | MedicalSystemRtSystemDto
    | QaEquipmentRtSystemDto
    | MedicalSystemCatalogDto
    | QaEquipmentCatalogDto,
): rtSystem is UnicheckDeviceDto | UnicheckSimulatorDto {
  if (instanceOfQaEquipmentRtSystemDto(rtSystem) || instanceOfQaEquipmentCatalogDto(rtSystem)) {
    return (
      rtSystem.deviceInterfaceType === DeviceInterfaceType.PtwioT ||
      rtSystem.deviceInterfaceType === DeviceInterfaceType.PtwLegacyIot
    );
  } else {
    return false;
  }
}

export function isSimulator(qaEquipment: QaEquipmentRtSystemDto | QaEquipmentCatalogDto) {
  return qaEquipment.typeNumber?.endsWith('.SIMU');
}
